/* eslint-disable  @typescript-eslint/no-explicit-any */
import type {PipeMiddlewareElement, PipeMiddlewareNext} from '../../middleware-pipe';
import type { MiddlewarePipeDetails } from '../../models/middleware-pipe-details.model';
import type { SearchTab } from '../../../../components/result-page/search-tab/search-tab';
import type {DashboardMisspellings} from '../../../../components/result-page/search-tab/subcomponents/dashboard-tab-view/dashboard-misspellings/dashboard-misspellings';
import type {CoseQueryBodyRequest} from '../../../../models/cose-api/request/query-body-request.model';
import {PassFacetStrategyService} from '../../../../components/strategies/PassFacetStrategyService';
import {PASS_FACET_INFO} from '../../../../components/strategies/utils/variables';
import {makeLogger} from '../../../../logger/logger';
import type {SearchApiDocument} from '../../../../api/model/response/documents/SearchResult';
import {FACET_CONDITIONS, FACET_MADE_IN_AMERICA} from '../../../../components/widgets/filter-related-widget/additional-conditions-banner/variables';

const {debug} = makeLogger({
  pathToCurrentFile: 'utils/middleware-pipe/pipes/cose/req-res-cose-build-query-after-events-with-products-facets.ts',
  loggersList: ['debug'],
});

interface MiddlewareRequestParams {
  language: string
  country: string
}

function getLocaleData(el: any, params: MiddlewareRequestParams) {  //eslint-disable-line
    const localeKey = `${params.language}_${params.country.toUpperCase()}`;
    if (el.hasOwnProperty(localeKey)) return el[localeKey];

    return el['en_WW'];
}

// extend document by circular economy label title
function circularEconomyDocumentsMap(
  documents: any,  //eslint-disable-line
  params: MiddlewareRequestParams
): Array<SearchApiDocument> {

    return documents.map((el) => {
        const localeData = getLocaleData(el, params);

        const document = {
          ...el,
        };

        if (localeData) {
          if (localeData.circularity)
          {
            document.circularNature = localeData?.circularity?.circularNature;
          }
        }

        return document;
    });
};

const setMiaData = (searchTab, response) => {
    // MiA filter is a nested characteristic so we need to get the first children and then map the values
    const miaFilters = response?.facetsOptions?.facets?.find(facet => facet.id === FACET_MADE_IN_AMERICA)?.children[0]?.children;
    const miaFilterValues = miaFilters?.map(child => child.value);
    if (miaFilterValues?.length > 0) {
      searchTab.parentDataFlux.root.miaData = {
        miaFilters: miaFilters?.map(child => child.value) || [],
        isAnyMiaFilterSelected: miaFilters?.some(filter => filter.selected === true)
      };
    }
    return miaFilters?.map(child => child.value);
};

export const reqResCoseBuildQueryAfterEventsWithProductsFacets: PipeMiddlewareElement<
  MiddlewarePipeDetails,
  any
> = async (
  details: MiddlewarePipeDetails,
  next: PipeMiddlewareNext<any>,
): Promise<any> => {
    const searchTab: SearchTab | DashboardMisspellings = details.context;

    debug('reqResCoseBuildQueryAfterEventsWithProductsFacets BEFORE',details);
    const response = await next(details);

    const newResponse = {...response};
    newResponse.documents = [...circularEconomyDocumentsMap(response.documents, {language: searchTab.language, country: searchTab.country})];

    //Per-tab loading
    if(!searchTab.isVisible ){
      // additional call for conditions facet to check if there are any number
      (async() => {

          const detailsForConditionsFacet = {...details};
          const isMiaPromotionWidget = searchTab?.isMiaPromotionWidget;
          if(detailsForConditionsFacet.middlewareRequest.requestBody && (detailsForConditionsFacet.middlewareRequest.requestBody as CoseQueryBodyRequest)?.facetsOptions)
          {
            let fetchList: string[];
            if(isMiaPromotionWidget) {
              fetchList = ['characteristics_made_in_america'];
            } else {
              fetchList = ['conditions'];
            }
            (detailsForConditionsFacet.middlewareRequest.requestBody as CoseQueryBodyRequest).facetsOptions
          = {...(detailsForConditionsFacet.middlewareRequest.requestBody as CoseQueryBodyRequest).facetsOptions,
             ...{fetch: true,
                 fetchList: [...fetchList]}
              };
          }
          const response = await next(detailsForConditionsFacet);

          const messageBox: PassFacetStrategyService = searchTab.strategies.for(PASS_FACET_INFO);
          debug('reqResCoseBuildQueryAfterEventsWithProductsFacets response', response);

          messageBox.resetFacetConditionsChildrenNames();
          let childrenNamesFromFacetCondtions: string[];
          if(isMiaPromotionWidget){
            childrenNamesFromFacetCondtions = setMiaData(searchTab, response);
          } else {
            childrenNamesFromFacetCondtions = response?.facetsOptions?.facets?.find(facet => facet.id === FACET_CONDITIONS)?.children.map(child => child.value);
          }
          messageBox.haveFacetConditionsChildrenNames(childrenNamesFromFacetCondtions);
      })();
    }

    setMiaData(searchTab, newResponse); // update MiA data after filter request

    const additionalWidget = document.querySelector('uiaas-search-widget-additional-conditions-banner');
    if (additionalWidget && (additionalWidget as any).SetFacets() && newResponse?.facets.length > 0)
    {
      (additionalWidget as any).SetFacets(newResponse?.facets);
    }

    debug('reqResCoseBuildQueryAfterEventsWithProductsFacets AFTER',newResponse);
    return new Promise((r) => r(newResponse));
};
